import React, { useEffect, useState } from "react";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import { Row, Col, Form, Card } from "react-bootstrap";
import ConnectPin from "../../../assets/images/ConnectPin.svg";
import ConnectCircle from "../../../assets/images/ConnectCircle.svg";
import { useLocation } from "react-router-dom";
import delivaApiService from "../../../common/services/apiService";
import { formatStatusMessage, getStatusClassName, toTitleCase } from "../../../common/helpers/Utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import WarningBox from "../../../common/helpers/WarningBox";
// import Alerts from "../DeliveryAgent/Alerts";

const RouteDetails = (props) => {
  const location = useLocation();
  const history = useHistory();

  const { route } = location.state || {};
  const [routeDetails, setRouteDetails] = useState("")

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getRouteDetails();
  }, []);

  const getRouteDetails = () => {
    delivaApiService("getRouteDetails", { routeId: route.routeId })
      .then((response) => {
        if (response?.data?.status === 200) {
          setRouteDetails(response.data.
            resourceData
          )
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const userId = localStorage.getItem("id");

  const handleSwitchChange = (routeId, isActive) => {
    const payload = {
      routeId: routeId,
      active: isActive,
      userId: userId,
    };

    delivaApiService("activeInactiveStatus", payload)
      .then((response) => {
        if (response?.data?.status === 200) {
          getRouteDetails();
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Failed to update status:", error);
      });
  };
  const handleClick = () => {
    history.push('/route-list')
  }

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                  Route Details
                </h3>
                <h5 className="font-weight-normal mb-0 line-ht color-head">
                  <span className="pointer" onClick={handleClick}>List of Routes</span>
                  <span className="icon-next mx-2 fs12"></span>
                  <span className="pointer">Route Details </span>
                </h5>
                <Card className="custom-card mt-4">
                  <Card.Body>
                    <Row>
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">Created By</span>
                        <p className="mb-lg-0 textBlack fs18 fw500">
                          {routeDetails.createdBy || "--"}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">Mobile No.</span>
                        <p className="mb-lg-0 textBlack fs18 fw500">
                          {routeDetails.mobile || "--"}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">
                          Delivery Type
                        </span>
                        <p className="mb-lg-0 textBlack fs18 fw500">
                          {toTitleCase(routeDetails?.deliveryType) || "--"}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">Subscribed</span>
                        <p className="mb-0 textBlack fs18 fw500">
                          {routeDetails?.subscribedCount || "--"}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">
                          Last Use Of The Route
                        </span>
                        <p className="mb-0 textBlack fs18 fw500">
                          {routeDetails?.lastUsedOfRoute || "--"}
                        </p>
                      </Col>

                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">
                          Associated Deliver Count
                        </span>
                        <p className="mb-0 textBlack fs18 fw500">
                          {routeDetails?.deliverCount}
                        </p>
                      </Col>
                      <Col lg={3}>
                        <span className="textGray fs18 mb-3">Status</span>

                        <p
                          className={`mb-0  fs18 fw500 ${getStatusClassName(
                            routeDetails?.status
                          )}`}
                        >
                          {routeDetails?.status || "--"}
                        </p>
                      </Col>
                    </Row>
                    <hr className="my-4" />
                    <Row>
                      <Col lg={4}>
                        <h4 className="textBlack fs18 fw400"> Route</h4>
                        <ul className="connection mb-4 mb-lg-0">
                          <li>
                            <img className="connect-icon" src={ConnectCircle} />
                            <span className="place">
                              {route?.source || "--"}
                            </span>
                          </li>
                          <li>
                            <img
                              className="connect-icon"
                              src={ConnectPin}
                              alt="Destination"
                            />
                            <span className="place">
                              {route?.destination || "--"}
                            </span>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <hr className="my-4" />

                    {/* <Alerts
      variant="danger"
      content={
        route.statusMessage && route.status === "Expiring soon"
          ? formatStatusMessage(route.statusMessage)
          : null
      }
      show={showAlert}
      className="mb-3"
      dismissible={true}
      onClose={() => setShowAlert(false)}
    /> */}
                    {route.statusMessage && route.status == "Expiring soon" && (<WarningBox statusMessage={formatStatusMessage(route.statusMessage)} islistPage={false} />

                    )}

                    <Row className="align-items-center">
                      <Col xs="auto">
                        <h4 className="textBlack fs18 fw400 mb-0">Inactive</h4>
                      </Col>

                      <Col xs="auto">
                        <Form.Check
                          type="switch"
                          id={`customSwitch${route.routeId}`}
                          label=""
                          className="custom-switch-green"
                          checked={routeDetails.active}
                          onChange={(e) =>
                            handleSwitchChange(routeDetails?.routeId, e?.target?.checked)
                          }
                        />
                      </Col>

                      <Col xs="auto">
                        <h4 className="textBlack fs18 fw400 mb-0">Active</h4>
                      </Col>
                    </Row>

                  </Card.Body>
                </Card>
              </div>
            </div>
            <Footer {...props} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RouteDetails;
